import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FaDownload } from 'react-icons/fa';
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const CVSection = () => {
  const { t } = useTranslation();
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const cvFile = '/cv.pdf';

  return (
    <CVContainer id="cv">
      <div className="container">
        <div className="section-title">
          <h2>{t('cv.title')}</h2>
        </div>
        
        <DownloadButton href={cvFile} download="Bartlomiej_Zawadzki_CV.pdf">
          <FaDownload /> {t('cv.download')}
        </DownloadButton>
        
        <CVContent>
          <Document
            file={cvFile}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={console.error}
            loading={<p>{t('common.loading')}</p>}
            error={<p>{t('common.error')}</p>}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                width={Math.min(window.innerWidth * 0.9, 800)}
              />
            ))}
          </Document>
        </CVContent>
      </div>
    </CVContainer>
  );
};

const CVContainer = styled.section`
  padding: 5rem 0;
  background-color: transparent;
  position: relative;
`;

const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--primary-color);
  color: var(--black);
  font-weight: 700;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-md);
  text-decoration: none;
  transition: all var(--transition-fast) ease;
  margin-bottom: 2rem;
  
  &:hover {
    background-color: var(--secondary-color);
    transform: translateY(-3px);
    box-shadow: var(--shadow-lg);
  }
`;

const CVContent = styled.div`
  background-color: var(--gray-100);
  padding: 1rem;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  max-width: 850px;
  margin: 0 auto;
  overflow-x: auto;

  .react-pdf__Page__canvas {
    margin: 0 auto;
    display: block;
    max-width: 100%;
    height: auto !important;
  }
`;

export default CVSection;